<template>
  <div class="row jipvio-dashboard">
    <div class="col-12">
      <card class="mt-70" card-body-classes="table-full-width" no-footer-line>
        <h4 class="card-title ml-20">게시판 관리 > 문의사항</h4>
        <div class="card-title ml-20 mb-30 row">
          <div class="col-sm-6 pl-0">
            <h4 class="fl ttl-label mr-20 mb-20">검색</h4>
            <fg-input>
              <el-select
                class="select-primary mb-3 fl mr-10"
                style="width: 200px"
                v-model="searchStd"
                placeholder="검색기준"
              >
                <el-option
                  class="select-default"
                  v-for="tc in tableColumns"
                  :key="tc.label"
                  :label="tc.label"
                  :value="tc.label"
                >
                </el-option>
              </el-select>
              <el-input
                type="search"
                class="mb-3 fl"
                clearable
                style="width: 200px"
                placeholder="Search records"
                v-model="searchQuery"
                aria-controls="datatables"
              >
              </el-input>
            </fg-input>
          </div>
          <div class="col-sm-6 pl-0 dashbrd-el-label">
            <h4 class="fl ttl-label mr-20">답변여부</h4>
            <el-checkbox-group v-model="checkList">
              <el-checkbox label="Y" checked></el-checkbox>
              <el-checkbox label="N"></el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <div>
          <el-table stripe style="width: 100%" :data="tableData">
            <el-table-column
              v-for="column in filteredColumns()"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
              align="center"
              :sortable="column.sortable"
            >
            </el-table-column>

            <el-table-column
              :min-width="135"
              fixed="right"
              label="작업"
              align="center"
            >
              <template v-slot="props">
                <div class="table-actions">
                  <router-link to="/mypage/admin/board/qst/regstr">
                    <n-button @click="printData(props.$index, props.row)">
                      답변
                    </n-button>
                  </router-link>
                  <n-button type="danger" style="margin-left:10px;">
                    삭제
                  </n-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <n-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.totalCnt"
          >
          </n-pagination>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  Select,
  Option,
  Input,
  Button,
  Popover,
  Checkbox,
  CheckboxGroup
} from "element-ui";
import { Pagination as NPagination } from "@/components";
import { Button as NButton } from "@/components";
import card from "@/components/Cards/Card.vue";
import propApi from "@/service/property";

import { createNamespacedHelpers } from "vuex";

const {
  mapGetters: sessionMapGetters,
  mapActions: sessionMapActions
} = createNamespacedHelpers("loginSession");

export default {
  components: {
    NPagination,
    NButton,
    card,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Input.name]: Input,
    [Button.name]: Button,
    [Popover.name]: Popover,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup
  },
  created() {
    console.log("======문의내역");
    console.log(this.sessionUserInfo);
    this.getAllProperty();
  },

  computed: {
    ...sessionMapGetters({
      sessionUserInfo: "getUserInfo"
    }),
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.totalCnt;
    }
  },
  data() {
    return {
      checkList: ["Option A"],
      activeName: "일반",
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        totalCnt: 0,
        totalPages: 10
      },
      searchStd: null,
      searchQuery: "",

      tableColumns: {
        NumBer: {
          label: "번호",
          minWidth: 100,
          sortable: true,
          vif: true
        },
        SubTitle: {
          label: "제목",
          minWidth: 150,
          sortable: true,
          vif: true
        },
        MemberName: {
          label: "작성자",
          minWidth: 110,
          sortable: true,
          vif: true
        },
        ClickCount: {
          label: "조회수",
          minWidth: 110,
          sortable: true,
          vif: true
        },
        RegistDate: {
          label: "등록일",
          minWidth: 100,
          sortable: true,
          vif: true
        },
        HeadlineYN: {
          label: "헤드라인",
          minWidth: 110,
          sortable: true,
          vif: true
        }
      },
      sor: false,
      tableData: null
    };
  },
  methods: {
    printData(index, row) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === row.id
      );
      console.log("here");
      console.log(index);
      console.log(row);
      console.log(indexToDelete);
    },

    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === row.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },

    async getAllProperty() {
      const pagingReq = {
        pageNo: this.pagination.currentPage - 1,
        sizePerPage: this.pagination.perPage,
        swLat: 37.66258399481432,
        swLng: 127.04401962842194,
        neLat: 37.66762719185185,
        neLng: 127.04979178950516
      };

      const res = await propApi.getAllProperty(pagingReq);

      this.pagination.perPage = res.pagingInfo.size;
      this.pagination.currentPage = res.pagingInfo.pageNo + 1;
      this.pagination.totalCnt = res.pagingInfo.totalCnt;
      this.pagination.totalPages = res.pagingInfo.totalPages;
      this.tableData = res.payload;
    },
    handleClick(tab, event) {
      console.log("==============tab");
      console.log(tab);
      console.log("==============event");
      console.log(event);
    },

    filteredColumns() {
      const newTbColumns = _.cloneDeep(this.tableColumns);
      for (let key in newTbColumns) {
        if (newTbColumns[key].vif == false) {
          delete newTbColumns[key];
        }
      }
      console.log(newTbColumns);
      return newTbColumns;
    }
  },
  mounted() {},
  watch: {
    "pagination.currentPage"(newValue, oldValue) {
      this.getAllProperty();
    },
    "pagination.perPage"(newValue, oldValue) {
      this.pagination.currentPage = 1;
      this.getAllProperty();
    }
  }
};
</script>
<style></style>
